import { useMediaQuery, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { AppStoreLogo } from 'components/icon'
import { useTranslations } from 'next-intl'

interface FormSuccessStepProps {
  image?: React.ReactNode
}

/**
 *
 * @description A screen for when the form is successfully submitted.
 * @param {FormSuccessStepProps} FormSuccessStepProps
 *
 */
const FormSuccessApplyStep = ({ image }: FormSuccessStepProps) => {
  const t = useTranslations('success')
  const { breakpoints } = useTheme()
  const isMediumScreen = useMediaQuery(breakpoints.down('md'))
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))
  const isBigScreen = useMediaQuery(breakpoints.up('md'))

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: isSmallScreen ? 'flex-start' : 'center',
      gap: '16px',
      marginTop: isSmallScreen || isMediumScreen ? '0' : '116px',
      marginBottom: isSmallScreen || isMediumScreen ? '80px' : '0',
      alignItems: 'center',
    },
    h4: {
      width: '100%',
      textAlign: isSmallScreen ? '' : 'center',
    },
    p: {
      textAlign: isSmallScreen ? '' : 'center',
      fontSize: isSmallScreen ? '14px' : '16px',
      margin: isSmallScreen || isBigScreen ? '0' : '0 4rem ',
    },
  }

  return (
    <Box sx={styles.container}>
      {image && (
        <Box
          sx={{
            width: '100%',
            maxWidth: '92px',
            height: '100%',
            maxHeight: '70px',
            margin: '0 auto 40px',
          }}
        >
          {image}
        </Box>
      )}
      <Typography variant={isSmallScreen ? 'h6' : 'h5'} sx={styles.h4}>
        {t('title')}
      </Typography>
      <Typography variant="body1" component="div" sx={styles.p}>
        Thank you for sending your application, please complete your profile to
        secure your spot on the platform. First come, first served.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          width: '100%',
          justifyContent: isSmallScreen ? 'flex-start' : 'center',
          marginTop: '24px',
        }}
      >
        <AppStoreLogo store="apple" dark small={isSmallScreen} />
        <AppStoreLogo store="google" dark small={isSmallScreen} />
      </Box>
    </Box>
  )
}

export default FormSuccessApplyStep
